<template>
    <div class="parentSchool">
        <!--家长教育-->
        <div class="content-EXM_F">
            <div class="layout-box-white-bg-ig6pe">
                <section class="simple-2S7p1">
                    <span class="title">家长教育</span>
                </section>
                <section class="custom-intro">
                    <div class="pic-cover">
                        <img :src="parentSchool.pic" alt="">
                    </div>
                    <div class="text-display">
                        <h2 class="title">课程背景</h2>
                        <div>
                            {{parentSchool.description}}
                        </div>
                    </div>
                </section>
                <div class="content-intro">
                    <h2 class="title">家长学堂使用指南</h2>
                    <img :src="parentSchool.guidePic" alt="家长学堂使用指南">
                </div>
                <div class="course-list">
                    <h2 class="title">家庭教育系列课程表</h2>
                    <el-table
                            :data="tableData"
                            border
                            :header-cell-style="{
                                        'background-color': '#f5f8ff',
                                        'color': '#000',
                                        'font-weight': '400'
                                    }"
                            style="width: 100%">
                        <el-table-column
                                prop="name"
                                label="课程名称"
                                >
                        </el-table-column>
                        <el-table-column
                                prop="categoryName"
                                label="课程栏目"
                                >
                        </el-table-column>
                        <el-table-column
                                prop="teacherName"
                                label="主讲人">
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            :hide-on-single-page="true"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage1"
                            :page-size="pageSize"
                            layout="prev, pager, next,  jumper"
                            :page-count="totalPage">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {parentSchoolDescription, parentSchoolCourseList} from "../../../config";
    export default {
        name: "parentSchool",
        data(){
            return{
                tableData:[],
                parentSchool:[],
                pageIndex:1,
                pageSize:10,
                total:1,
                currentPage1:1,
                totalPage:1,
            }
        },
        methods:{
            async getParentSchoolDescription(){
                let res  = await parentSchoolDescription();
                if (res.status){
                  this.parentSchool = res.data;

                }
            },
            async getParentSchoolCourseList(){
                let res = await parentSchoolCourseList(this.pageIndex,this.pageSize);
                if (res.status){
                    this.tableData = res.data.data;
                    //总内容数量
                    this.total = res.data.totalRecords;
                    //总内容的页数
                    this.totalPage = res.data.totalPages;
                    //当前页码
                    this.currentPage1 = res.data.pageIndex;
                }
            },
            //改变时
            handleSizeChange(val1) {
                this.pageSize = val1;
                this.getTestList(val1);
            },
            //条目改变时
            handleCurrentChange(val1) {
                this.pageIndex = val1;
                this.getTestList(val1);
            },

        },
        created() {
            this.getParentSchoolDescription();
            this.getParentSchoolCourseList();
        }
    }
</script>

<style scoped lang="scss">

    .parentSchool {
        .content-EXM_F {
            padding: 24px 32px;

            .layout-box-white-bg-ig6pe {
                background-color: #fff;
                padding: 0 32px 32px 32px;

                .simple-2S7p1 {
                    border-bottom: 1px solid #E6EAF5;
                    font-size: 18px;
                    padding: 22px 0;
                    color: #373a44;
                    position: relative;
                    margin-bottom: 16px;
                }

                .custom-intro {
                    padding: 15px 25px;
                    background-color: #F5F8FF;

                    .pic-cover {
                        margin-right: 40px;
                        float: left;

                        img {
                            max-width: 100%;
                        }
                    }

                    .text-display {
                        font-size: 14px;
                        color: #96a2be;
                        line-height: 22px;

                        .title {
                            font-size: 26px;
                            font-weight: 600;
                            color: #3d4d75;
                            line-height: 32px;
                            margin: 24px 0 9px;
                        }
                    }
                }
                .content-intro {
                    background: #f5f8ff;
                    border-radius: 8px;
                    margin: 24px 0 8px;
                    padding: 40px;
                    .title {
                        font-size: 26px;
                        font-weight: 600;
                        color: #3d4d75;
                        line-height: 32px;
                        margin-bottom: 57px;
                    }
                     img {
                        max-width: 100%;
                    }
                }
                .course-list{
                    padding: 40px;
                    .title {
                        font-size: 26px;
                        font-weight: 600;
                        color: #3d4d75;
                        line-height: 32px;
                        margin-bottom: 57px;
                    }
                }
            }
        }
    }
</style>
